import { Component, HostListener, Input, OnDestroy, OnInit, OnChanges, SimpleChanges} from '@angular/core';
import { Constant } from '../../../environments/constants';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import { Utils } from '../../../utils/utils';
import * as fromModel from '../../services/models';
import * as Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
import { RefDataService } from '../../services/context/ref-data.service';
import xrange from "highcharts/modules/xrange";
xrange(Highcharts);
addMore(Highcharts);

@Component({
  selector: 'gp-milestone',
  templateUrl: './milestone.component.html',
  styleUrls: ['./milestone.component.scss']
})
export class MilestoneComponent implements OnInit, OnChanges, OnDestroy {

  protected _storeDataSubscription: Subscription;
  Highcharts: typeof Highcharts = Highcharts;
  options: Highcharts.Options;
  private chart: Highcharts.Chart;
  isDataAvailable = false;

  goalSummary = [];
  lifeEvents = [];
  goalsRef: fromModel.CodeValue[] = [];
  lifeEventsOnly = false;
  
  constructor(private dataService: DataService,
      private refDataService: RefDataService,
      private uiStateService: UIStateService,  
      private appMonitoringService: AppMonitoringService) {    
  }

  ngOnInit(): void {
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));      
    this.dataService.getGoalSummary();
    this.goalsRef  = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Goals);
    this.populateGoalSummary();
  }

  ngOnChanges(changes: SimpleChanges){    
  }

  private populateAppData(appData: fromModel.IAppData){
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){
      this.populateGoalSummary();      
    }
  }

  private populateGoalSummary(){
      this.goalSummary = this.dataService.getGoalSummaryArray();           
      if(this.goalSummary && this.goalSummary["Error"]){
        this.isDataAvailable = true;
        this.uiStateService.dispatchAction(fromModel.UI_STATE_ACTION.SHOWERRORMSG, "MilestoneComponent-populateGoalSummary", {ShowMsg: true, MsgType: fromModel.MSGTYPE.ERROR ,Msg: Constant.ErrorMsgs.systemErrorMsg});
      } else if(this.goalSummary && this.goalSummary.length>0) {
        this.isDataAvailable = true;
        this.lifeEvents = this.dataService.getLifeEventArray();
        this.setChartOptionsData();
      }
  }

  private setChartOptionsData(){
    this.options = {
      chart: {
        style: {
          fontSize: '18',                    
        },
        //height: 70,
        

      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      credits: {
        enabled: false
      },
      xAxis: {
        title: {              
          text: '',
          style: {
            fontSize: '16',
          }
        },
        labels: {
          style: {            
              fontSize:'14'
          }
        },
        type: 'datetime',
        startOnTick: true,
        tickInterval: 1000 * 60 * 60 * 24 * 1825,  
        visible: true,
        //endOnTick: true,
        //showFirstLabel: true,
        //showLastLabel: true,
        crosshair: {
          width: 1,
          zIndex: 5,
          dashStyle: 'Dash',
          color: 'gray'
        },  
      },
      yAxis: {
        title: {
          text: ''
        },
        labels: {
          style: {                
              fontSize: '16'
          }
        },
        categories: [],
        reversed: true,
        gridLineColor: 'white',
        crosshair: {
          width: 1,
          zIndex: 5,
          dashStyle: 'Dash',
          color: 'gray'
        },
      },
      legend: {
        enabled: true,        
        itemStyle:{
          fontSize: '14'
        }       
        // symbolWidth: 0.1,
        // symbolHeight: 0.1,        
        // itemStyle:{
        //   fontSize: '14'
        // } ,
        // labelFormatter: function() {
        //   if(this.name === 'Series 5'){                                    
        //     return '';
        //   } else {
        //     return 
        //   } 
        // }
      },  
      tooltip: {
        //shared : true,
        formatter: function () {
          if(this.series.type === 'xrange'){            
            if(Highcharts.dateFormat('%Y', this.point.x) !== Highcharts.dateFormat('%Y', this.point.x2)){
              return '<b>' + this.point['goalName'] + '</b><br><b></b>' + Highcharts.dateFormat('%Y', this.point.x) + '-' + Highcharts.dateFormat('%Y', this.point.x2);            
            } else {
              return '<b>' + this.point['goalName'] + '</b><br><b></b>' + Highcharts.dateFormat('%Y', this.point.x);              
            }
          } else  if(this.series.type === 'scatter'){
            //return '<b>' + Highcharts.dateFormat('%Y', this.point.x) + '</b><br>' + this.point['pName'] + this.point['pAge'] + this.point['sName'] + this.point['sAge'] + this.point['desc'];
            if(this.point['sName'] && this.point['sAge']){
              return '<b>' + Highcharts.dateFormat('%Y', this.point.x) + '</b><br>' + this.point['pName'] + ': ' + this.point['pAge'] + ' years<br>' + this.point['sName'] + ': ' + this.point['sAge'] + ' years<br><br><b>' + this.point['desc'] +'</b>';
            } else {
              return '<b>' + Highcharts.dateFormat('%Y', this.point.x) + '</b><br>' + this.point['pName'] + ': ' + this.point['pAge'] + ' years' + '<br><br><b>' + this.point['desc'] +'</b>';
            }
          }
        }
      },
      plotOptions: {
        series: {
            stickyTracking: false,
            states: {
                inactive: {
                    opacity: 1
                }
            }
        }
      }, 
      series: []
    }; 

    let { yAxis } = this.options;
    yAxis = this.getYAxisLabels(yAxis);
    this.options = {...this.options, yAxis};

    let { series } = this.options;
    series = this.getChartData(series);
    this.options = {...this.options, series};
  }

  private getYAxisLabels(yAxis){
    if(!this.lifeEventsOnly && this.goalSummary && this.goalSummary.length>0){
      this.goalSummary.forEach(_goalSumm => {
        if(_goalSumm && _goalSumm.GoalSummary && _goalSumm.GoalSummary.totalAmtPV>0){          
          yAxis.categories.push(_goalSumm.goalDesc.toUpperCase());
        }
      });      
      yAxis.categories.push("KEY LIFE EVENTS");
    }    
    return yAxis;
  }

  private getChartData(series){
    series = [];
    let data = [];
    let _data;
    let goalStartYr;
    let goalEndYr;
    let i:number=0;
    let start;
    let end;
    let startYrs = [];
    let endYrs = [];
    if(this.goalSummary && this.goalSummary.length>0){
      
      this.goalSummary.forEach(_goalSumm => {
        if(_goalSumm && _goalSumm.GoalSummary && _goalSumm.GoalSummary.totalAmtPV>0){

          if(_goalSumm.GoalSummary.startYr === _goalSumm.GoalSummary.endYr){
            goalStartYr = Date.UTC(Number(_goalSumm.GoalSummary.startYr),0, 1);
            goalEndYr = Date.UTC(Number(_goalSumm.GoalSummary.endYr), 11, 31);  
          }
          else {
            goalStartYr = Date.UTC(Number(_goalSumm.GoalSummary.startYr), 0, 1); 
            goalEndYr = Date.UTC(Number(_goalSumm.GoalSummary.endYr), 0, 1); 
          }          
          

          startYrs.push(_goalSumm.GoalSummary.startYr);
          endYrs.push(_goalSumm.GoalSummary.endYr);

          _data = {
            x: goalStartYr,
            x2: goalEndYr,
            y: i,
            color: this.getChartGradient(_goalSumm.color),
            goalName: _goalSumm.goalDesc.toUpperCase(),            
          };
          data.push(_data);
          if(i===0){
            start = goalStartYr;
          } else {
            end = goalEndYr;
          }
          i++;
        }
      });
      if(!this.lifeEventsOnly){
        series = [{type: 'xrange', borderRadius: 0, showInLegend: false, pointPadding: 0, pointWidth: 20, data: data}];
      } else {
        i =0;
        series = [];
      }
    }
    
    if(this.lifeEvents && this.lifeEvents.length>0){
      //Utils.applyOrderBy(this.lifeEvents, 'ASC', 'yr', true);
      
      //lifeEventLine
      startYrs.push(this.lifeEvents[0].yr);
      this.lifeEvents.forEach(lifeEvent => {
        endYrs.push(lifeEvent.yr);      
      });
      start = Date.UTC(new Date().getFullYear(), 0, 1);

      
      end = Date.UTC(Number(Math.max(...endYrs)), 0, 1);  ;
      let lifeEventLineMarker = { enabled: true, symbol:"diamond", radius: 5, fillColor: '#F2E2C4'};
      let lifeEventLine = {type: 'line', showInLegend: false, marker: lifeEventLineMarker, lineWidth: 4, color: '#F2E2C4', data:[[start,i],[end,i]], enableMouseTracking: false, dataLabels: {enabled: true, verticalAlign: 'bottom', style: { fontSize: '16'}, formatter: function () { return Highcharts.dateFormat('%Y', this.point.x); } }};       
      series.push(lifeEventLine);

      //lifeEvent Points
      let marker;
      let yr;
      let leData;
      let cNameAge;
      this.lifeEvents.forEach(lifeEvent => {
        if(lifeEvent.lifeEventCd !== fromModel.LIFEEVENTTYPES.END){
          if(lifeEvent.lifeEventCd === fromModel.LIFEEVENTTYPES.RET){
            marker = { enabled: true, symbol:"triangle", radius: 10, fillColor: lifeEvent.color};
          } else if(lifeEvent.lifeEventCd === fromModel.LIFEEVENTTYPES.SSELG){ 
            marker = { enabled: true, symbol:"circle", radius: 8, fillColor: lifeEvent.color};
          } else {
            marker = { enabled: true, symbol:"circle", radius: 8, fillColor: lifeEvent.color};
          }
          yr = Date.UTC(Number(lifeEvent.yr), 0, 1);   
          
          cNameAge = this.dataService.getClientNameAge(lifeEvent.yr);
          if(this.dataService.isSecondaryClient()){            
            leData = [{x: yr, y: i, pName: cNameAge.pName, pAge: cNameAge.pAge, sName: cNameAge.sName, sAge: cNameAge.sAge ,clientname: lifeEvent.clientname, desc: lifeEvent.desc}];
          } else {
            leData = [{x: yr, y: i, pName: cNameAge.pName, pAge: cNameAge.pAge, clientname: lifeEvent.clientname, desc: lifeEvent.desc}];
          }

          if(lifeEvent.lifeEventCd === fromModel.LIFEEVENTTYPES.RET){
            series.push({name: 'Retirement for ' + lifeEvent.clientname, type: 'scatter', showInLegend: true, data: leData, marker: marker});
          } else {
            series.push({type: 'scatter', showInLegend: false, data: leData, marker: marker});
          }          
        }
      });
    }
    return series;
  }

  getChartGradient(gradientRange){
    let color;
    let gradients = gradientRange.split(",");
    let _stop = [];
    let linearGradient;
    gradients.forEach((gd,i) => {
      _stop.push([i, gd]);
    });
    color = {
      linearGradient: { x1: 0, x2: 1, y1: 1, y2: 0 },
      stops: _stop
    }
    return color;
  }

  @HostListener('window:resize', ['$event'])
  onResize(){
    if(this.chart) {
      this.chart.reflow();
    }
  }

  public chartCallBack = (chart: Highcharts.Chart) => {
    this.chart =  chart;
    setTimeout(() => {
      if(this.chart && this.chart.hasOwnProperty('series')) {
        this.chart.reflow();
      }
    }, 300);
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }    
  }
}
